<header class="eclaim-header">
  <div class="eclaim-header__wrapper">
    <a href="https://www.manulife.co.jp/" class="eclaim-header__logo-link">
      <img src="assets/images/jp_logo-jp.svg" alt="Manulife Logo" class="eclaim-header__logo" />
    </a>
  </div>
</header>